import { createTheme } from '@mui/material/styles';

export default mainColor => createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: mainColor,
    },
    // secondary: {
    //   main: 'var(--secondary-theme-color)',
    // },
  },
  typography: {
    fontFamily: 'Helvetica',
    fontSize: 15,
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          height: 40,
          lineHeight: 40,
          fontSize: 16,
          color: "#4f4f4f",
        }
      }
    },
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          borderRadius: '8px',
          border: '1px solid #D9D9D9',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "Helvetica",
          height: "100%",
          padding: '0 1.35em',
          borderRadius: '8px',
          boxShadow: "inset 0 3px 5px 0 rgba(0, 0, 0, 0.22)",
          border: "solid 1px #BABA  ",
          '&.MuiInputBase-readOnly': {
            backgroundColor: '#EDEDED',
            boxShadow: 'none',
            border: 'solid 1px #d9d9d9',
            color: '#7F7F7F',
            cursor: 'not-allowed',
          }
        },
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          display: 'none',
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "Helvetica",
          height: "100%",
          padding: '0 1.35em',
          borderRadius: '8px',
        },
        input: {
          padding: 0,
        },
        notchedOutline: {
          display: 'none',
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        height: "unset",
        minWidth: 0,
      },
    },
    MuiClock: {
      styleOverrides: {
        amButton: {
          height: "unset",
        },
        pmButton: {
          height: "unset",
        },
        root: {
          paddingTop: '40px',
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        valueLabel: {
          backgroundColor: '#fff',
          color: '#000',
          borderRadius: 10,
          border: '1px solid #BABABA',
          padding: '8px 18px',
          '&::before': {
            borderBottom: '1px solid #BABABA',
            borderRight: '1px solid #BABABA',
          },
        },
        rail: {
          height: '8px',
          backgroundColor: '#f7f7f7',
          borderRadius: '4px',
          boxShadow: 'inset 0 1px 2px 0 rgba(0, 0, 0, .13)',  
        },
        track: { color: mainColor },
        thumb: {
          '&::before': {
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, .14)',
            backgroundColor: '#fff',
            width: '30px',
            height: '30px',
            borderRadius: '15px',
          }
        },
      }
    },
  }
})
